import * as Yup from "yup";
import { isEmpty } from "lodash";
import { RecordsToOverride, SelectedPrimaryRecords } from "./Utils";

const ValidationSchema = attributeValues => {
  return Yup.object()
    .shape({
      override_action: Yup.string().required("Required"),
      override_attribute: Yup.string().required("Required"),
      override_system: Yup.string().when("override_attribute", {
        is: attribute => ["identifier"].includes(attribute),
        then: Yup.string().required("Required")
      }),
      override_system: Yup.string().when("override_attrCode", {
        is: attribute =>
          ["phone", "email", "address", "name"].includes(attribute),
        then: Yup.string().required("Required")
      }),
      override_code: Yup.string().when("override_system", {
        is: system => system === "[No System]",
        then: Yup.string().required("Required")
      }),
      override_correct_value: Yup.string().when("override_action", {
        is: action => action === "replace",
        then: Yup.string()
          .required("Required")
          .test(
            "notSameAsIncorrectValue",
            "Cannot be the same as Incorrect Value",
            function(value) {
              return value !== this.parent.override_incorrect_value;
            }
          )
      }),
      override_incorrect_value: Yup.string()
        .required("Required")
        .test(
          "notSameAsCorrectValue",
          "Cannot be the same as Correct Value",
          function(value) {
            return value !== this.parent.override_correct_value;
          }
        )
    })
    .test({
      name: "minimumOneValueOverridden",
      message: "There must be at least one value overridden",
      test: values => {
        if (
          values.override_attribute &&
          values.override_action &&
          values.override_incorrect_value
        ) {
          const records = RecordsToOverride(
            attributeValues,
            values.override_attribute,
            values.override_system,
            values.override_attrCode,
            values.override_action,
            values.override_incorrect_value,
            values.override_code
          );
          return typeof records !== "undefined" && !isEmpty(records);
        }
      }
    });
};

export default ValidationSchema;
